exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail-header[data-v-3f31560a] {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.title[data-v-3f31560a] {\n  margin-right: 0.052083rem;\n}\n.guide-tip[data-v-3f31560a] {\n  background: #00b8f5;\n  border-radius: 0.026042rem;\n  width: 0.125rem;\n  height: 0.125rem;\n  text-align: center;\n  margin-right: 0.052083rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.guide-content-container[data-v-3f31560a] {\n  font-size: 12PX;\n  margin-right: 0.15625rem;\n}", ""]);

// exports
